var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "type_one_title" }, [
      _c("span", { staticClass: "bold_size" }, [_vm._v("当前认证企业：")]),
      _vm._v("\n    " + _vm._s(_vm.license.enterpriseName) + "\n  ")
    ]),
    _c("ul", { staticClass: "auth_list" }, [
      _c(
        "li",
        {
          class: ["auth_card", { active: _vm.activeTable === 1 }],
          on: {
            click: function($event) {
              return _vm.activeTableFn(1)
            }
          }
        },
        [_vm._m(0), _c("p", [_vm._v("通过短信或二维码邀请法定代表人完成认证")])]
      ),
      _c(
        "li",
        {
          class: ["auth_card auth_card2", { active: _vm.activeTable === 2 }],
          on: {
            click: function($event) {
              return _vm.activeTableFn(2)
            }
          }
        },
        [_vm._m(1), _c("p", [_vm._v("打印授权书并盖章，线上上传完成认证")])]
      ),
      _c(
        "li",
        {
          class: ["auth_card auth_card2", { active: _vm.activeTable === 3 }],
          on: { click: _vm.moreAuthTypeShowEmit }
        },
        [_vm._m(2), _c("p", [_vm._v("直接认证 >>")])]
      )
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTable === 1,
            expression: "activeTable === 1"
          }
        ],
        staticClass: "type_one"
      },
      [
        _c("span", { staticStyle: { color: "rgba(0, 0, 0, 0.7)" } }, [
          _vm._v(
            "可通过以下两种方式邀请法定代表人快速认证，二维码/短信链接有效期7天"
          )
        ]),
        _c("div", { staticClass: "submit_card" }, [
          _c("ul", { staticClass: "submit_list" }, [
            _c(
              "li",
              {
                class: ["list_once", { active: _vm.activeTableSecond === 1 }],
                on: {
                  click: function($event) {
                    return _vm.activeTableSecondFn(1)
                  }
                }
              },
              [
                _c("span", { staticClass: "radio" }),
                _c("span", [_vm._v("分享二维码/链接")])
              ]
            ),
            _c(
              "li",
              {
                class: [
                  "list_once list_once2",
                  { active: _vm.activeTableSecond === 2 }
                ],
                on: {
                  click: function($event) {
                    return _vm.activeTableSecondFn(2)
                  }
                }
              },
              [
                _c("span", { staticClass: "radio" }),
                _c("span", [_vm._v("直接发送短信")])
              ]
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTableSecond === 1,
                  expression: "activeTableSecond === 1"
                }
              ],
              staticClass: "qrcode_box"
            },
            [
              _c("qrcode", {
                key: "evidence",
                attrs: { value: _vm.qrCodeImg, size: 140, leave: "H" }
              }),
              _c(
                "div",
                { staticClass: "qrcode_btn" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "qrcode_href_copy",
                      attrs: {
                        "data-clipboard-text": _vm.qrCodeImg,
                        size: "small"
                      },
                      on: { click: _vm.copyHrefFn }
                    },
                    [_vm._v("复制链接")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "small" },
                      on: { click: _vm.getProfileFn }
                    },
                    [_vm._v("查询认证结果")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTableSecond === 2,
                  expression: "activeTableSecond === 2"
                }
              ],
              staticClass: "sms_box"
            },
            [
              _vm.smsAuthVisible
                ? _c("div", { staticClass: "sms_loading" }, [
                    _c("i", {
                      staticClass: "el-icon-time",
                      staticStyle: {
                        color: "#ec1c1c",
                        "font-size": "38px",
                        "font-weight": "bold"
                      }
                    }),
                    _c("p", { staticStyle: { margin: "20px 0" } }, [
                      _vm._v(
                        "\n            已向法定代表人 " +
                          _vm._s(_vm.license.enterpriseController) +
                          "（" +
                          _vm._s(_vm.moblieData.phone) +
                          "）发送认证短信，请及时通知法定代表人完成认证！\n          "
                      )
                    ]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.smsAgainFn(0)
                              }
                            }
                          },
                          [_vm._v("修改手机号")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.smsAgainFn(1)
                              }
                            }
                          },
                          [_vm._v("再次发送短信")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "small" },
                            on: { click: _vm.getProfileFn }
                          },
                          [_vm._v("查询认证结果")]
                        )
                      ],
                      1
                    )
                  ])
                : _c(
                    "el-form",
                    {
                      ref: "moblieDataRef",
                      staticClass: "sms_form",
                      attrs: {
                        model: _vm.moblieData,
                        rules: _vm.rules,
                        size: "small",
                        "label-width": "150px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { prop: "phone", label: "法定代表人手机号:" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 11,
                              minlength: 11,
                              placeholder: "法定代表人手机号"
                            },
                            model: {
                              value: _vm.moblieData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.moblieData, "phone", $$v)
                              },
                              expression: "moblieData.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "padding-top": "15px"
                          }
                        },
                        [
                          _c(
                            "aliCaptcha",
                            {
                              attrs: {
                                verify: _vm.getPhoneCode,
                                mobile: _vm.moblieData.phone,
                                verifyType: _vm.BUSITYPE.FASTACCOUNT,
                                handCallback: _vm.handCallback
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "danger" } },
                                [_vm._v("确认发送")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ])
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTable === 2,
            expression: "activeTable === 2"
          }
        ],
        staticClass: "type_second"
      },
      [
        _c(
          "div",
          { staticClass: "second_left" },
          [
            _c("word-Custom", {
              ref: "wordCustomRef",
              attrs: {
                isInLand: _vm.isInLand,
                license: _vm.license,
                grantAuth: _vm.grantAuth
              }
            })
          ],
          1
        ),
        _c("ul", { staticClass: "second_right" }, [
          _c(
            "li",
            { staticClass: "second_right_li" },
            [
              _c("p", { staticClass: "right_li_btn" }, [
                _vm._v("1.信息填写完成，下载授权书，打印并加盖公章")
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "danger",
                    plain: "",
                    loading: _vm.loadingBtn
                  },
                  on: { click: _vm.downloadFileFn }
                },
                [_vm._v("下载授权书")]
              )
            ],
            1
          ),
          _c(
            "li",
            { staticClass: "second_right_li" },
            [
              _c("p", { staticClass: "right_li_btn" }, [
                _vm._v("2.将加盖公章的授权书扫描或拍照后上传")
              ]),
              _c(
                "el-upload",
                {
                  ref: "uploadCare",
                  staticStyle: { width: "200px" },
                  attrs: {
                    action: "#",
                    accept: ".jpg, .png, .jpeg",
                    "file-list": _vm.fileList,
                    "on-remove": _vm.romeFileFn,
                    "before-upload": function(file) {
                      return _vm.beforeIdeCareUpload(file)
                    }
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "danger",
                        plain: "",
                        loading: _vm.loadingBtn
                      }
                    },
                    [_vm._v("上传授权书")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [_vm._v("（支持jpg、png格式）")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "li",
            { staticClass: "second_right_li" },
            [
              _c("p", { staticClass: "right_li_btn" }, [
                _vm._v("\n          3. 提交认证，\n          "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isInLand,
                        expression: "isInLand"
                      }
                    ]
                  },
                  [_vm._v("被授权人完成人脸识别，")]
                ),
                _vm._v("等待君子签审核\n        ")
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "danger",
                    loading: _vm.loadingBtn
                  },
                  on: { click: _vm.submitFn }
                },
                [_vm._v("提交认证")]
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _c("div", { staticClass: "span" }, [_vm._v("邀请法定代表人快速认证")]),
      _c("p", { staticClass: "card_tips" }, [_vm._v("2分钟极速认证")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _c("div", { staticClass: "span" }, [_vm._v("企业授权书认证")]),
      _c("p", { staticClass: "card_tips" }, [_vm._v("1个工作日")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _c("div", { staticClass: "span" }, [_vm._v("我是法定代表人")]),
      _c("p", { staticClass: "card_tips" }, [_vm._v("极速认证")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-759f4255", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759f4255","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/moreAuthType.vue
// module id = a9GI
// module chunks = 38 105